/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import baseApi from '@features/base/BaseSlice';
import { NotificationApiProps, NotificationProps } from './types';
import notification from './notification';

const notificationTag = baseApi.enhanceEndpoints({ addTagTypes: [notification.tagType] });
const notificationAPi = notificationTag.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<NotificationApiProps, void>(notification.getEntities()),
    updateNotification: builder.mutation<
      void,
      Pick<NotificationProps, 'id'> & Partial<NotificationProps>
    >(notification.updateNotification()),
  }),
  overrideExisting: false,
});

export const { useGetNotificationsQuery, useUpdateNotificationMutation } = notificationAPi;
